import React, {useState} from 'react';
import * as XLSX from "xlsx"
import {EyeOutlined, DownloadOutlined} from "@ant-design/icons";
import shablon from "../../../../../files/fao/meteodata.xlsx"
function Meteo() {
    const [fileData,setFileData] = useState([])
    const mdata = localStorage.getItem('sfr-fao-mdata')
    const [meteoData,setMeteoData] = useState(mdata?JSON.parse(mdata):[])
    const getFile = (e) => {

        const reader = new FileReader();
        reader.readAsBinaryString(e.target.files[0]);
        reader.onload = (e) => {
            const data = e.target.result;
            const workbook = XLSX.read(data,{type:"binary",cellDates: true});
            const sheetName = workbook.SheetNames[0]
            const sheet = workbook.Sheets[sheetName]
            let parseData = XLSX.utils.sheet_to_json(sheet,{header:3})
            parseData.map((p,i)=>{
                if(!isNaN(new Date(p.sana))){
                    if(p.sana && i > 1){
                        parseData[i].sana = new Date(p.sana).getTime()+86400000
                    }
                }
            })
            setFileData(parseData)
        }
    }
    const fetchData = () => {
        setMeteoData([...fileData])
    }
    const loadData = () => {
        localStorage.setItem('sfr-fao-mdata',JSON.stringify(meteoData))
        window.location.href = "/sfr/fao/xisob"
    }
    return (
        <div className="row">
            <div className="col-12">
                <div className="row">
                    <p className="m-0 pt-2">Fayl tanlang (xls/xlsx)</p>
                    <div className="col-8">
                        <div className="form-group">
                            <input
                                type="file"
                                className="form-control"
                                accept=".xlsx, .xls"
                                onChange={getFile}
                            />
                        </div>
                    </div>
                    <div className="col-2">
                        <button className="btn btn-primary d-flex align-items-center" disabled={fileData.length?false:true} onClick={fetchData}><EyeOutlined/>&nbsp;&nbsp;Ko'rish</button>
                    </div>
                    <div className="col-2">
                        <a className="btn btn-primary d-flex align-items-center" download href={shablon}><DownloadOutlined />&nbsp;&nbsp;Shablon</a>
                    </div>
                </div>
            </div>
            <div className="col-12 mt-2">
                <div className="mx-auto" style={{maxWidth:"700px"}}>
                    {
                        meteoData.length?
                            <table className="table table-bordered">
                                <thead>
                                <tr>
                                    <th rowSpan={2} className="text-center vertical-middle" width={120}>Sana</th>
                                    <th colSpan={2} className="text-center vertical-middle">T-havo</th>
                                    <th colSpan={2} className="text-center vertical-middle">Havo namligi, %</th>
                                    <th rowSpan={2} className="text-center vertical-middle">u2 -shamol tezligi, m/s</th>
                                    <th rowSpan={2} className="text-center vertical-middle">Yog'in miqdori, mm</th>
                                    <th rowSpan={2} className="text-center vertical-middle">n - Xaqiqiy yorug' kun davomiyligi, soat</th>
                                </tr>
                                <tr>
                                    <th className="text-center vertical-middle">Maksimal l</th>
                                    <th className="text-center vertical-middle">Minimal l</th>
                                    <th className="text-center vertical-middle">Maksimal l</th>
                                    <th className="text-center vertical-middle">Minimal l</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    meteoData.map((m,i)=>{
                                        if(i > 1){
                                            return <tr key={i}>
                                                <td>{m.sana?new Date(m.sana).toISOString().slice(0,10):''}</td>
                                                <td>{m.max_xavo}</td>
                                                <td>{m.min_xavo}</td>
                                                <td>{m.max_nam}</td>
                                                <td>{m.min_nam}</td>
                                                <td>{m.shamol_tezlik}</td>
                                                <td>{m.yogin_mm}</td>
                                                <td>{m.kun_soat}</td>
                                            </tr>
                                        }
                                    })
                                }
                                </tbody>
                            </table>
                            :null
                    }
                </div>
            </div>
            <div className="col-12 text-center">
                {meteoData.length?<button className="btn btn-primary" onClick={loadData}>Yuklash</button>:null}
            </div>
        </div>
    );
}

export default Meteo;